import aboutOrderSopAddItemsModalImage from "../../../assets/images/about-order-sop/about-order-sop-add-items-modal.png";
import aboutOrderSopBarcodeInputImage from "../../../assets/images/about-order-sop/about-order-sop-barcode-input.png";
import aboutOrderSopBarcodeScannerImage from "../../../assets/images/about-order-sop/about-order-sop-barcode-scanner.png";
import aboutOrderSopCreateOrderCustomerImage from "../../../assets/images/about-order-sop/about-order-sop-create-order-customer.png";
import aboutOrderSopCreateOrderStoreImage from "../../../assets/images/about-order-sop/about-order-sop-create-order-store.png";
import aboutOrderSopDraftOrderImage from "../../../assets/images/about-order-sop/about-order-sop-draft-order.png";
import aboutOrderSopCompleteOrderImage from "../../../assets/images/about-order-sop/about-order-sop-complete-order.png";
import aboutOrderSopCreatePaymentImage from "../../../assets/images/about-order-sop/about-order-sop-create-payment.png";
import aboutOrderSopInvoicePartialPaidImage from "../../../assets/images/about-order-sop/about-order-sop-invoice-partial-paid.png";
import aboutOrderSopInvoiceUnpaidImage from "../../../assets/images/about-order-sop/about-order-sop-invoice-unpaid.png";
import aboutOrderSopOrderPaidImage from "../../../assets/images/about-order-sop/about-order-sop-order-paid.png";
import aboutOrderSopIssueInvoiceImage from "../../../assets/images/about-order-sop/about-order-sop-issue-invoice.png";
import aboutOrderSopNewCustomerImage from "../../../assets/images/about-order-sop/about-order-sop-new-customer.png";
import aboutOrderSopOfferAcceptedImage from "../../../assets/images/about-order-sop/about-order-sop-offer-accepted.png";
import aboutOrderSopRecordPaymentImage from "../../../assets/images/about-order-sop/about-order-sop-record-payment.png";
import aboutOrderSopReviewConfirmImage from "../../../assets/images/about-order-sop/about-order-sop-review-confirm.png";
import aboutOrderSopSalesOrdersImage from "../../../assets/images/about-order-sop/about-order-sop-sales-orders.png";

import type { AboutOrderSopImageConfig } from "../types";
import { PublicInfoImageLayout } from "../enums";

export const ABOUT_ORDER_SOP_IMAGES: Record<string, AboutOrderSopImageConfig> =
  {
    "sales-orders": {
      src: aboutOrderSopSalesOrdersImage,
      altKey: "about-order-sop-image-sales-orders-alt",
      altFallback:
        "Sales Orders list with search, status filter, and the purple New Order button"
    },
    "create-order-store": {
      src: aboutOrderSopCreateOrderStoreImage,
      altKey: "about-order-sop-image-create-order-store-alt",
      altFallback: "Create Sales Order modal with the Store dropdown selected"
    },
    "create-order-customer": {
      src: aboutOrderSopCreateOrderCustomerImage,
      altKey: "about-order-sop-image-create-order-customer-alt",
      altFallback:
        "Create Sales Order modal with customer search and the add-customer plus button"
    },
    "new-customer": {
      src: aboutOrderSopNewCustomerImage,
      altKey: "about-order-sop-image-new-customer-alt",
      altFallback:
        "New customer form with name, customer type, phone, and email fields"
    },
    "draft-order": {
      src: aboutOrderSopDraftOrderImage,
      altKey: "about-order-sop-image-draft-order-alt",
      altFallback:
        "Draft order details page showing customer, store, and empty order items"
    },
    "barcode-scanner": {
      src: aboutOrderSopBarcodeScannerImage,
      altKey: "about-order-sop-image-barcode-scanner-alt",
      altFallback:
        "Handheld USB barcode scanner for scanning product item QR codes",
      layout: PublicInfoImageLayout.CONTAIN
    },
    "barcode-input": {
      src: aboutOrderSopBarcodeInputImage,
      altKey: "about-order-sop-image-barcode-input-alt",
      altFallback: "Order page barcode scan field with Add Item button"
    },
    "add-items-modal": {
      src: aboutOrderSopAddItemsModalImage,
      altKey: "about-order-sop-image-add-items-modal-alt",
      altFallback:
        "Add items to order modal with Product and Product item dropdowns"
    },
    "review-confirm": {
      src: aboutOrderSopReviewConfirmImage,
      altKey: "about-order-sop-image-review-confirm-alt",
      altFallback:
        "Order items list with subtotal, tax, total, and Confirm Order button"
    },
    "offer-accepted": {
      src: aboutOrderSopOfferAcceptedImage,
      altKey: "about-order-sop-image-offer-accepted-alt",
      altFallback:
        "Confirmed order with Offer accepted status and Issue Invoice button"
    },
    "issue-invoice": {
      src: aboutOrderSopIssueInvoiceImage,
      altKey: "about-order-sop-image-issue-invoice-alt",
      altFallback: "Issue Invoice confirmation dialog for a confirmed order"
    },
    "record-payment": {
      src: aboutOrderSopRecordPaymentImage,
      altKey: "about-order-sop-image-record-payment-alt",
      altFallback: "Order page with View Invoice link and Record Payment button"
    },
    "invoice-unpaid": {
      src: aboutOrderSopInvoiceUnpaidImage,
      altKey: "about-order-sop-image-invoice-unpaid-alt",
      altFallback:
        "Unpaid invoice page with subtotal, tax, total, and remaining amount"
    },
    "create-payment": {
      src: aboutOrderSopCreatePaymentImage,
      altKey: "about-order-sop-image-create-payment-alt",
      altFallback:
        "Create Payment modal with amount, method, date, and optional reference fields"
    },
    "invoice-partial-paid": {
      src: aboutOrderSopInvoicePartialPaidImage,
      altKey: "about-order-sop-image-invoice-partial-paid-alt",
      altFallback:
        "Invoice with PARTIAL_PAID status and a list of recorded payments"
    },
    "order-paid": {
      src: aboutOrderSopOrderPaidImage,
      altKey: "about-order-sop-image-order-paid-alt",
      altFallback: "Paid order showing View Invoice and View Receipt links"
    },
    "complete-order": {
      src: aboutOrderSopCompleteOrderImage,
      altKey: "about-order-sop-image-complete-order-alt",
      altFallback:
        "Order items summary with Complete Order and Cancel Order buttons"
    }
  };
